module.exports = "/_next/static/images/kh-b3dadd9fb54156c59835b3b65694d075.svg";